import React from 'react';
import  ChilderensDay2023  from 'views/ChilderensDay2023';
// import ChilderensDay2023 from 'views/ChilderensDay2023/Index'

const SchoolProgrampage = () => {
  return <ChilderensDay2023 />;
};

export default SchoolProgrampage;